import { render, staticRenderFns } from "./guess_the_score.vue?vue&type=template&id=996079f4&"
import script from "./guess_the_score.vue?vue&type=script&lang=js&"
export * from "./guess_the_score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports